// extracted by mini-css-extract-plugin
export default {"toast":"styles_toast__FE+-W","body":"styles_body__Zkdjf"};